import domReady from 'domready';
import React from 'react';
import Layout from 'shared-view/layout/layout-shared-view';
import AppTop from "./top-shared-view";
import ModalsManager from "src/core/gd-modals/modals";
import AppModal from '../../src/app/ui/modal/modal-app';
import Growl from '../../src/layout/components/growl/growl-app';
import initGlobalVars from "../global-vars";

import extendConsole from "src/core/gd/console"

const { when } = require('simply-deferred');

initGlobalVars()


window.gdConfig = require('./config/' + process.env.BUILD_CONFIG + '.js');
window.gd = require("./gd/gd");

// import userSwitchedListener from 'core/gd/user-switched-listener';

// const debug = "StartSharedViewApp"
const debug = false

export default class StartSharedViewApp {

    constructor() {

        debug && console.log(debug, "constructor()")

        // extend default console with special methods
        extendConsole();

        this.init();
    }

    init() {
        debug && console.log(debug, "init()")

        gd.initBeforeDataRequest()

        // we need to run it before load resources so we could init skin
        gd.initOnSessionData()

        this.loadResources();
    }

    loadResources() {
        // update screen
        $("#gd-load-caption").html("Resources...");

        // we need to init skin loader first
        gd.skin.init();

        when(gd.skin.loadDeferred('shared-view','shared-view')).then(
            ()=>{ this.start(); },
            ()=>{ $("#gd-load").html("Error loading resources"); }
        );
    }

    start() {
        // userSwitchedListener();

        gd.init();

        gd.layout = new Layout();
        gd.layout.render();

        gd.top = new AppTop();
        gd.top.render();

        gd.modal = new AppModal();
        gd.modal.init();

        gd.modals = new ModalsManager();

        gd.growl = new Growl();

        gd.start();

        $("#gd-load").remove();
        $("body").removeClass('load-ing');
    }
}


// prevent opening files after drop on non-dropzone area
function preventDropFilesOpen() {

    window.addEventListener("dragover", function (e) {
        e = e || event;
        e.preventDefault();
    }, false);

    window.addEventListener("drop", function (e) {
        e = e || event;
        e.preventDefault();
    }, false);
}
preventDropFilesOpen();

domReady(()=>{new StartSharedViewApp()});
